/* Kiseau Batch 002 — Countdown custom element */
(function () {
  if (customElements.get('batch-countdown')) return;

  class BatchCountdown extends HTMLElement {
    connectedCallback() {
      const targetStr = this.getAttribute('data-target');
      if (!targetStr) {
        this.innerHTML = '';
        return;
      }
      this.target = new Date(targetStr).getTime();
      this.variant = this.getAttribute('data-variant') || 'light';
      this.labels = {
        days: this.getAttribute('data-label-days') || 'Days',
        hours: this.getAttribute('data-label-hours') || 'Hrs',
        minutes: this.getAttribute('data-label-minutes') || 'Min',
        seconds: this.getAttribute('data-label-seconds') || 'Sec',
      };
      this.render();
      this.interval = setInterval(() => this.render(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    render() {
      const now = Date.now();
      const distance = Math.max(0, this.target - now);
      const day = 1000 * 60 * 60 * 24;
      const hour = 1000 * 60 * 60;
      const minute = 1000 * 60;

      const days = Math.floor(distance / day);
      const hours = Math.floor((distance % day) / hour);
      const minutes = Math.floor((distance % hour) / minute);
      const seconds = Math.floor((distance % minute) / 1000);

      const pad = (n) => String(n).padStart(2, '0');

      const variantClass =
        this.variant === 'compact-dark' ? 'b002-countdown--dark b002-countdown--compact' :
        this.variant === 'dark' ? 'b002-countdown--dark' :
        this.variant === 'compact' ? 'b002-countdown--compact' :
        '';

      this.innerHTML = `
        <div class="b002-countdown ${variantClass}" role="timer" aria-live="off">
          <div class="b002-countdown__cell">
            <span class="b002-countdown__num">${pad(days)}</span>
            <span class="b002-countdown__label">${this.labels.days}</span>
          </div>
          <span class="b002-countdown__sep" aria-hidden="true">:</span>
          <div class="b002-countdown__cell">
            <span class="b002-countdown__num">${pad(hours)}</span>
            <span class="b002-countdown__label">${this.labels.hours}</span>
          </div>
          <span class="b002-countdown__sep" aria-hidden="true">:</span>
          <div class="b002-countdown__cell">
            <span class="b002-countdown__num">${pad(minutes)}</span>
            <span class="b002-countdown__label">${this.labels.minutes}</span>
          </div>
          <span class="b002-countdown__sep" aria-hidden="true">:</span>
          <div class="b002-countdown__cell">
            <span class="b002-countdown__num">${pad(seconds)}</span>
            <span class="b002-countdown__label">${this.labels.seconds}</span>
          </div>
        </div>
      `;
    }
  }

  customElements.define('batch-countdown', BatchCountdown);
})();
